<!-- Основные параметры заказ-наряда ремонта. -->
<template>
  <BaseFormSection title="Заказ-наряд" icon="info">
    <!-- Машина ремонтируется всегда явно -->
    <BaseFormField
      label="Транспорт"
      for-id="repair_vehicle"
      required
      :filled="isFieldFilled('vehicle_id')"
      :error="errors.vehicle_id"
      wide
    >
      <div class="vehicle-picker">
        <FleetParkSelect
          :model-value="formData.fleet_park_id"
          placeholder="Все автопарки"
          :with-button="false"
          @update:model-value="handleFleetParkChange"
        />

        <VehicleSelect
          id="repair_vehicle"
          :model-value="formData.vehicle_id"
          placeholder="Выберите транспорт"
          :clearable="false"
          :fleet-park-id="formData.fleet_park_id"
          :invalid="errors.vehicle_id"
          @update:model-value="handleFieldChange('vehicle_id', $event)"
        />
      </div>
    </BaseFormField>

    <BaseFormField
      label="Дата ремонта"
      for-id="repair_performed_at"
      required
      :filled="isFieldFilled('performed_at')"
      :error="errors.performed_at"
    >
      <base-input
        id="repair_performed_at"
        :model-value="formData.performed_at"
        type="datetime-local"
        :invalid="errors.performed_at"
        @update:model-value="handleFieldChange('performed_at', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Ответственный"
      for-id="repair_responsible"
      required
      :filled="isFieldFilled('responsible_id')"
      :error="errors.responsible_id"
    >
      <CompanyUserSelect
        id="repair_responsible"
        :model-value="formData.responsible_id"
        placeholder="Выберите ответственного"
        :clearable="false"
        @update:model-value="handleFieldChange('responsible_id', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Контрагент"
      for-id="repair_counterparty"
      :filled="isFieldFilled('counterparty_id')"
    >
      <CounterpartySelect
        id="repair_counterparty"
        :model-value="formData.counterparty_id"
        placeholder="Сервис или поставщик"
        with-button
        button-label="Добавить контрагента"
        @button-click="$emit('open-counterparty-modal')"
        @update:model-value="handleFieldChange('counterparty_id', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Пробег"
      for-id="repair_odometer"
      :filled="isFieldFilled('odometer')"
    >
      <base-input
        id="repair_odometer"
        :model-value="formData.odometer"
        type="big_number"
        min="0"
        placeholder="Например: 198300"
        @update:model-value="handleFieldChange('odometer', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Статус"
      for-id="repair_status"
      :filled="isFieldFilled('status')"
    >
      <FleetRepairStatusSelect v-if="repair" :repair="repair" @changed="$emit('status-changed', $event)" />
      <base-select
        v-else
        id="repair_status"
        :model-value="formData.status"
        :options="statusOptions"
        :clearable="false"
        @update:model-value="handleFieldChange('status', $event)"
      />
    </BaseFormField>
  </BaseFormSection>
</template>

<script>
import FleetRepairStatusSelect from "@/components/Fleet/Repair/Status/Select.vue";
import CompanyUserSelect from "@/components/CompanyUser/CompanyUserSelect.vue";
import CounterpartySelect from "@/components/Counterparty/CounterpartySelect.vue";
import FleetParkSelect from "@/components/Vehicle/FleetParkSelect.vue";
import VehicleSelect from "@/components/Vehicle/VehicleSelect.vue";

export default {
  name: "FleetRepairMainSection",

  components: {
    FleetRepairStatusSelect,
    CompanyUserSelect,
    CounterpartySelect,
    FleetParkSelect,
    VehicleSelect,
  },

  props: {
    repair: { type: Object, default: null },
    errors: { type: Object, required: true },
    formData: { type: Object, required: true },
    statusOptions: { type: Array, required: true },
  },

  emits: ["status-changed", "clear-error", "open-counterparty-modal", "update-field"],

  methods: {
    handleFieldChange(field, value) {
      this.$emit("update-field", field, value);
      this.$emit("clear-error", field);
    },

    handleFleetParkChange(value) {
      this.$emit("update-field", "fleet_park_id", value);
      this.$emit("update-field", "vehicle_id", null);
    },

    isFieldFilled(field) {
      return Boolean(this.formData[field]);
    },
  },
};
</script>

<style scoped>
.vehicle-picker {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--base-in-indent);
}
</style>
